<div [class]="this.containerClass()">
  @for (action of this.visibleActions(); track action.type) {
    <cam-button
      type="secondary"
      [size]="this.large() ? 'large' : 'small'"
      [icon]="this.large() ? action.icon : null"
      (action)="this.addLine.emit(action.type)"
    >
      {{ action.label | translate }}
    </cam-button>
  }
</div>
